import SiteDetailFacts from './SiteDetailFacts';
import SiteDetailHeader from './SiteDetailHeader';
import SiteDetailHistory from './SiteDetailHistory';
import SiteDetailToolbar from './SiteDetailToolbar';
import SiteDetailTrend from './SiteDetailTrend';
import RunEvaluationDialog from '../../components/RunEvaluationDialog';
import { useSiteDetailController } from './useSiteDetailController';

import '../../../application/pages/ApplicationDetailsPage/ApplicationDetailsPage.css';

const SiteDetailPage = () => {
  const {
    emptyStateMessage,
    errorMessage,
    factsProps,
    headerProps,
    historyProps,
    isMobileViewport,
    runEvaluationProps,
    toolbarProps,
    trendProps,
  } = useSiteDetailController();

  if (errorMessage) {
    return (
      <div className="flex min-h-[240px] w-full items-center justify-center rounded border border-red-200 bg-red-50 px-4 text-center text-sm text-red-700">
        {errorMessage}
      </div>
    );
  }

  if (emptyStateMessage) {
    return (
      <div className="flex min-h-[240px] w-full items-center justify-center rounded border border-gray-200 bg-white px-4 text-center text-sm text-gray-500">
        {emptyStateMessage}
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col gap-x-6 gap-y-4 lg:flex-row max-sm:h-auto">
      <div className="flex w-full flex-col gap-4 lg:h-full lg:min-h-0 lg:w-[350px] lg:gap-12 lg:overflow-y-auto lg:border-r lg:border-gray-200 lg:pr-4">
        <SiteDetailHeader {...headerProps} />
        <SiteDetailFacts {...factsProps} />
        <SiteDetailTrend {...trendProps} />
      </div>

      <div className="relative flex h-full min-w-0 flex-col gap-4 sm:flex-1 max-sm:h-auto max-sm:w-full">
        {!isMobileViewport ? <SiteDetailToolbar {...toolbarProps} /> : null}
        {isMobileViewport ? (
          <div className="application-details-cards-container flex w-full flex-col gap-4 pr-1">
            <SiteDetailHistory {...historyProps} />
          </div>
        ) : (
          <div className="flex min-h-0 flex-1 flex-col overflow-y-auto pr-1">
            <SiteDetailHistory {...historyProps} />
          </div>
        )}
      </div>
      <RunEvaluationDialog {...runEvaluationProps} />
    </div>
  );
};

export default SiteDetailPage;